import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styles from "./styles.module.css";
import modalImg from "../../../../../../../reactjs/static/images/checkout/gainful_modal.png";
import modalImgWebp from "../../../../../../../reactjs/static/images/checkout/gainful_modal.webp";
function IngredientsModal(props) {
    const bagName = props.name.toLowerCase() === "guest" ? "For You" : props.name;
    const greeting = props.name.toLowerCase() === "guest" ? "Personalized" : "Hello";
    return (_jsxs("div", { className: styles.modalContainer, children: [_jsxs("div", { className: styles.greeting, children: [greeting, "\u00A0", bagName] }), _jsxs("div", { className: styles.imgWrapper, children: [_jsxs("picture", { children: [_jsx("source", { srcSet: modalImgWebp, type: "image/webp" }), _jsx("img", { className: styles.img, src: modalImg, alt: "" })] }), _jsx("div", { className: styles.name, children: bagName })] })] }));
}
export default IngredientsModal;
